import { useState } from 'react';
import { api } from '../lib/api';
import { ErrorBanner } from './ui';

export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign in failed');
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--color-paper)] px-5">
      <form onSubmit={submit} className="card w-full max-w-sm px-7 py-8">
        <div
          className="mx-auto mb-5 flex h-11 w-11 items-center justify-center rounded-[14px] font-display text-lg font-bold text-white"
          style={{ background: 'linear-gradient(135deg, var(--color-coral-500), var(--color-blue-600))' }}
          aria-hidden
        >
          T
        </div>
        <h1 className="text-center text-2xl">Timesheet</h1>
        <p className="mt-1.5 mb-6 text-center text-[13px] text-[var(--color-ink-muted)]">
          Sign in to log and review your hours.
        </p>

        {error && (
          <div className="mb-4">
            <ErrorBanner message={error} />
          </div>
        )}

        <label className="label" htmlFor="password">
          Password
        </label>
        <input
          id="password"
          type="password"
          className="field"
          autoFocus
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit" className="btn btn-primary mt-5 w-full" disabled={busy || !password}>
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
}
